import moment, { Moment } from "moment";
import { Fragment, useState } from "react";
import { useAsync } from "react-async";
import { useLocation } from "react-router-dom";
import { InvoiceSummaryReportModel } from "../../api/models/invoiceSummaryReport";
import { getInvoiceSummaryReport } from "../../api/services/invoiceService";
import Layout from "../../components/layout";
import queryString from 'query-string';
import InvoiceSummaryReportResponse from '../../api/responses/invoiceSummaryReportResponse';
import InvoiceSummaryReport from "../../components/invoiceSummaryReport";


// Variables & general utility functions
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
const dateRangeFormat: string = 'MM/DD/YYYY';

const getMonthDateRange = (year: number, month: number) => {
    const startDate: Moment = moment([year, month - 1]);
    const endDate: Moment = moment(startDate).endOf('month');

    return { start: startDate, end: endDate };
}

const getServicePeriod = (year: number, month: number) => {
    const range = getMonthDateRange(year, month);
    return `${range.start.format(dateRangeFormat)} to ${range.end.format(dateRangeFormat)}`;
}

const initializeData = async ({ districtId, year, month, programId }: any) => {
    return await getInvoiceSummaryReport(districtId, year, month, programId);
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


// Main component
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
const InvoiceSummary = () => {

    // Variables / Constants
    //---------------------------------------------------------------------------------------------
    const location = useLocation();
    const parsedQueryString = queryString.parse(location.search);
    const districtId = Number(parsedQueryString.districtId);
    const programId = !parsedQueryString.programId ? null : Number(parsedQueryString.programId);
    const year = Number(parsedQueryString.year);
    const month = Number(parsedQueryString.month);
    const servicePeriod = getServicePeriod(year, month);
    //---------------------------------------------------------------------------------------------

    // States
    //---------------------------------------------------------------------------------------------
    const [report, setReport] = useState<InvoiceSummaryReportModel>();
    //---------------------------------------------------------------------------------------------


    // API operations
    //---------------------------------------------------------------------------------------------
    const loadSummaryReportAsync = useAsync({
        promiseFn: initializeData,
        districtId: districtId,
        year: year,
        month: month,
        programId,
        onResolve: (response: InvoiceSummaryReportResponse) => {
            if (response) {
                const summaryReportData = response?.data.report;
                setReport(summaryReportData);
            }
        },
    });
    //---------------------------------------------------------------------------------------------


    // UI layout
    //---------------------------------------------------------------------------------------------
    return (
        <Layout isLoading={loadSummaryReportAsync.isLoading}>
            <Fragment>
                <div className='px-4 py-3 mt-1 bg-white rounded-lg shadow main-page-body print:px-0'>
                    <InvoiceSummaryReport
                        report={report}
                        servicePeriod={servicePeriod}
                    />
                </div>
            </Fragment>
        </Layout>
    )
    //---------------------------------------------------------------------------------------------
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

export default InvoiceSummary;
